export const futureEffectCss = `
@keyframes templateRevealFade { from { opacity: 0; } to { opacity: 1; } }
@keyframes templateRevealSlide { from { opacity: 0; transform: translateY(26px); } to { opacity: 1; transform: translateY(0); } }
@keyframes templateRevealScale { from { opacity: 0; transform: scale(.97); } to { opacity: 1; transform: scale(1); } }
@keyframes templateRevealBlur { from { opacity: 0; filter: blur(14px); } to { opacity: 1; filter: blur(0); } }
@keyframes templateGradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
[data-future-hover-lift="true"] > section,
[data-future-hover-glow="true"] > section { transition: transform .28s ease, box-shadow .28s ease, filter .28s ease; }
[data-future-hover-lift="true"]:hover > section { transform: translateY(-6px) scale(var(--future-hover-scale)); }
[data-future-tilt="true"]:hover > section { transform: perspective(900px) rotateX(var(--future-tilt-depth)); }
[data-future-hover-glow="true"]:hover > section { box-shadow: 0 0 var(--future-glow-spread) var(--future-glow-color); }
[data-future-card-density="dense"] article { padding: 16px !important; }
[data-future-card-density="airy"] article { padding: 32px !important; }
[data-future-card-equal-height="true"] article { height: 100%; }
[data-future-heading-gradient="true"] h1,
[data-future-heading-gradient="true"] h2 { background: linear-gradient(135deg, var(--future-heading-start), var(--future-heading-end)); -webkit-background-clip: text; background-clip: text; color: transparent !important; letter-spacing: var(--future-heading-tracking); }
[data-future-text-balance="true"] h1,
[data-future-text-balance="true"] h2,
[data-future-text-balance="true"] h3 { text-wrap: balance; }
[data-future-highlight-marker="true"] mark { border-radius: 6px; padding: 0 .2em; background: color-mix(in srgb, var(--future-heading-start), white 78%); }
[data-future-body-scale="large"] p { font-size: 1.08em; line-height: 1.75; }
[data-future-body-scale="compact"] p { font-size: .95em; line-height: 1.55; }
[data-future-muted-opacity="true"] p { opacity: var(--future-muted-opacity); }
[data-future-number-style="mono"] strong { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }
[data-future-number-style="display"] strong { font-size: 1.14em; }
[data-future-number-style="badge"] strong { border: 1px solid currentColor; border-radius: 999px; padding: .12em .45em; }
[data-future-callout-tone="info"] blockquote,
[data-future-callout-tone="premium"] blockquote,
[data-future-callout-tone="success"] blockquote,
[data-future-callout-tone="warning"] blockquote { border-left: 3px solid var(--future-heading-start); padding-left: 16px; }
[data-future-parallax-depth="true"] > section { transform: translateY(calc(var(--future-parallax-depth) * -1)); }
[data-future-section-divider="line"] > section { border-bottom: 1px solid var(--future-divider-color); }
[data-future-section-divider="angle"] > section { clip-path: polygon(0 0, 100% 0, 100% calc(100% - 24px), 0 100%); }
[data-future-section-divider="gridline"] > section { box-shadow: inset 0 -1px 0 var(--future-divider-color); }
[data-future-section-divider="soft-fade"] > section { box-shadow: inset 0 -42px 42px -54px var(--future-divider-color); }

/* Reader theme consistency bridge: make published/live reader obey the same template tokens as builder preview. */
.template-reader,
.template-reader * {
  box-sizing: border-box;
}

.template-reader {
  font-family: var(--template-font-family, Inter, Arial, sans-serif);
  background: var(--template-background-color, #ffffff);
  color: var(--template-text-color, #111827);
  zoom: var(--template-reader-scale, 1);
}

.template-reader section {
  font-family: var(--template-font-family, Inter, Arial, sans-serif);
}

.template-reader h1,
.template-reader h2,
.template-reader h3,
.template-reader h4,
.template-reader h5,
.template-reader h6 {
  font-family: var(--template-heading-font-family, var(--template-font-family, Inter, Arial, sans-serif)) !important;
  font-weight: var(--template-heading-weight, inherit) !important;
}

.template-reader p,
.template-reader span,
.template-reader li,
.template-reader label,
.template-reader input,
.template-reader select,
.template-reader textarea,
.template-reader button,
.template-reader a {
  font-family: var(--template-font-family, Inter, Arial, sans-serif);
}

.template-reader button,
.template-reader [role="button"],
.template-reader a[style*="inline-flex"],
.template-reader input[type="button"],
.template-reader input[type="submit"] {
  border-radius: var(--template-button-radius, 999px) !important;
  min-height: var(--template-button-height, 44px) !important;
}

.template-reader input,
.template-reader select,
.template-reader textarea {
  border-radius: var(--template-input-radius, 12px) !important;
  border-color: var(--template-border-color, #e5e7eb) !important;
}

.template-reader article,
.template-reader form,
.template-reader figure,
.template-reader [class*="card" i],
.template-reader [class*="tile" i] {
  border-radius: var(--template-card-radius, 18px) !important;
  border-color: var(--template-border-color, #e5e7eb) !important;
}

.template-reader img:not([alt*="logo" i]) {
  border-radius: var(--template-image-radius, 16px) !important;
}

.template-reader[data-template-domain="WAAS"] footer:not(.awp-footer):not(.aip-footer),
.template-reader[data-template-domain="WAAS"] #waas-template-footer {
  background: var(--template-footer-background, var(--template-background-color, #ffffff)) !important;
  color: var(--template-footer-text, var(--template-text-color, #111827)) !important;
  border-color: var(--template-footer-border, var(--template-border-color, #e5e7eb)) !important;
}
`;
